module.exports = __webpack_public_path__ + "static/img/mood4.b1bd96a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood4.png
// module id = XUuf
// module chunks = 1